import React from "react";
import "./ActivityFeed.css";

export interface ActivityItem {
  id: string;
  type: "word_click" | "bingo";
  timestamp: number;
  playerName: string;
  playerId: string;
  // For word_click
  word?: string;
  marked?: boolean;
  // For bingo
  bingoCount?: number;
  bingoLines?: string[]; // e.g., ["Reihe 1", "Spalte 3", "Diagonale"]
}

interface ActivityFeedProps {
  activities: ActivityItem[];
}

export const ActivityFeed: React.FC<ActivityFeedProps> = ({ activities }) => {
  const formatTimestamp = (timestamp: number) => {
    const now = Date.now();
    const diff = now - timestamp;

    if (diff < 60000) return "gerade eben";
    if (diff < 3600000) return `vor ${Math.floor(diff / 60000)}m`;
    if (diff < 86400000) return `vor ${Math.floor(diff / 3600000)}h`;
    return new Date(timestamp).toLocaleTimeString("de-DE", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const renderActivity = (activity: ActivityItem) => {
    if (activity.type === "word_click") {
      return (
        <div
          key={activity.id}
          className="activity-feed__item activity-feed__item--word"
        >
          <div className="activity-feed__icon">
            {activity.marked ? "✓" : "○"}
          </div>
          <div className="activity-feed__content">
            <div className="activity-feed__player">{activity.playerName}</div>
            <div className="activity-feed__text">
              {activity.marked ? "hat markiert" : "hat abgewählt"}{" "}
              <span className="activity-feed__word">"{activity.word}"</span>
            </div>
            <div className="activity-feed__time">
              {formatTimestamp(activity.timestamp)}
            </div>
          </div>
        </div>
      );
    }

    if (activity.type === "bingo") {
      return (
        <div
          key={activity.id}
          className="activity-feed__item activity-feed__item--bingo"
        >
          <div className="activity-feed__icon activity-feed__icon--bingo">
            🎉
          </div>
          <div className="activity-feed__content">
            <div className="activity-feed__player activity-feed__player--bingo">
              {activity.playerName}
            </div>
            <div className="activity-feed__text">
              {activity.bingoCount === 1
                ? "hat BINGO!"
                : `hat ${activity.bingoCount}x BINGO!`}
            </div>
            {activity.bingoLines && activity.bingoLines.length > 0 && (
              <div className="activity-feed__bingo-lines">
                {activity.bingoLines.map((line, idx) => (
                  <span key={idx} className="activity-feed__bingo-line">
                    {line}
                  </span>
                ))}
              </div>
            )}
            <div className="activity-feed__time">
              {formatTimestamp(activity.timestamp)}
            </div>
          </div>
        </div>
      );
    }

    return null;
  };

  return (
    <div className="activity-feed">
      <div className="activity-feed__list">
        {activities.length === 0 ? (
          <div className="activity-feed__empty">Noch keine Aktivitäten</div>
        ) : (
          activities.map(renderActivity)
        )}
      </div>
    </div>
  );
};
